import { computed } from 'vue'

export const user = computed(() => ({
  ...currentUser,
  hasPermission(permission) {
    if (typeof currentTeamPermissions === 'object' && currentTeamPermissions.length > 0) {
      // user has full access
      if (currentTeamPermissions.length === 1 && currentTeamPermissions[0] === '*') {
        return true
      }
      return this.isCompany && currentTeamPermissions.includes(permission)
    }
    return !this.userIsTeamMember
  },
  get isGuest() {
    return typeof currentUser !== 'object'
  },
  isCompany: currentUser.is_company === 1,
  userIsTeamMember: currentUser.team_member !== null && typeof currentUser.team_member === 'object',
}))
